











import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import FilterSection from '@/components/filter/FilterSection.vue';
import MultipleSelectMixin from '@/mixins/MultipleSelectMixin.vue';
import { FilterOption } from '@/models';
import MultipleSelect from '../shared/MultipleSelect.vue';

@Component({
  mixins: [MultipleSelectMixin],
  components: {
    FilterSection,
    MultipleSelect,
  },
})
export default class HistoriesTypeFilter extends Vue {
  @Getter('historicListTypeOptions', { namespace: 'schemes' })
  private options!: FilterOption[];

  @Getter('selectedHistoricListTypeOptions', { namespace: 'schemes' })
  private selected!: string[];

  public title = 'Type';

  public toggleCheckbox(options): void {
    this.$emit('on-histories-type-change', options);
  }
}
